<div class="position-relative flex-column d-flex loading-tour-stop ">
  <div class="text-right">

    <div class="top-right-img">

      <img src="../../../assets//border-loading-tour.svg" alt="" />
    </div>
  </div>
  <div class="m-auto loading-tour-middle">
    <div class="loading-tour-img ">
  
      <img src="../../../assets/walking.svg" alt="" width="64px" height="98px" />
    </div>
    <div class="loading-tour-text text-center d-flex flex-column align-items-center">
      <h5>{{ 'loadingStop.loadingTourStop' | translate }}</h5>
      <h6 *matches="'mobile'">{{ 'loadingStop.forBestExperience' | translate }}</h6>
      <p *matches="'mobile'">{{ 'loadingStop.wiFiIsTurnedOff' | translate }}</p>
    </div>
    <div class="pt-2 d-flex flex-column align-items-center">
      <ng-container *ngIf="!loaded">
        <ng-lottie [options]="options"></ng-lottie>
      </ng-container>
      <ng-container *ngIf="loaded">
        <img src="../../../assets/go-down.svg" class="go-next-svg" width="73px" height="72px" alt="" (click)="continue.emit()"/>
        <a class="pt-3 h6" (click)="continue.emit()">{{ 'loadingStop.loadingTour' | translate }}</a>
      </ng-container>
    </div>
  </div>
  <div class="loading-tour-bottomBorder">
    <img src="../../../assets/rightborder.svg" alt="" height="259px" />
  </div>
</div>